import { DatadogRUM } from '@user-portal/datadog-rum';
import React from 'react';
import { createRoutesFromElements, Route } from 'react-router-dom';

import { RootLayout } from 'router/layouts';
import { routes } from 'router/routes';

import ProtectedRoute from './ProtectedRoute';
import RootBoundary from './RootBoundary';

const createBrowserRouter = DatadogRUM.getReactRouter();

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<RootLayout />} errorElement={<RootBoundary />}>
            {routes.map((route) => {
                const {
                    path,
                    layout: Layout,
                    component: Component,
                    titleKey,
                    withCenteredContent,
                    validators,
                    redirectPath,
                    loader,
                } = route;

                return (
                    <Route
                        key={path}
                        path={path}
                        loader={loader}
                        element={
                            <ProtectedRoute validators={validators} redirectPath={redirectPath}>
                                <Layout titleKey={titleKey} withCenteredContent={withCenteredContent}>
                                    <Component />
                                </Layout>
                            </ProtectedRoute>
                        }
                    />
                );
            })}
        </Route>
    )
);

export default router;
